import { sineOut } from "svelte/easing";

let duration = 250;
let delay = duration;

export const fadeIn = _ => ({
    duration,
    delay,
    easing: sineOut,
    css: t => {
        return t < 0.001 ?
            `position: absolute; z-index: -1; opacity: ${t};`
            : `position: relative; opacity: ${t}`
    }

});
export const fadeOut = _ => ({
    duration,
    delay: 0,
    easing: sineOut,
    css: t => `opacity: ${t}`
});